import React, { useMemo } from "react";
import {useSelector} from "react-redux";

//components:
import {NetgraphWrapper} from "../../../../widgets/stats/NetgraphWrapper";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

//helpers:
import {useWindowSize} from "../../../../../_metronic/_helpers";

const MetricsNetgraph = ({selectedInsights = []}) => {
    const windowSize = useWindowSize();
    const isDesktop = windowSize.width > 768;

    //redux:
    //store:
    const {
        metricsNetgraphData = [],
        metricsNetgraphConfig = {},
        netgraphError = {},
        isLoadingMetricsNetgraphData = true,
    } = useSelector(state => state.settings);

    const selectedInsightsKeys = useMemo(() => {
        return selectedInsights?.map(d => d.key)
    }, [selectedInsights]);

    return (
        <>
            {netgraphError?.text ? (
                <div className="d-flex justify-content-center align-items-center w-fit-content">
                    <div className="alert alert-light font-size-h5 font-weight-bold">
                        <WarningRoundedIcon color="inherit" className="mr-5" />
                        {netgraphError.text}
                    </div>
                </div>
            ) : null}
            <NetgraphWrapper
                aspectRatio={isDesktop ? 16 / 9 : 16 / 14}
                config={metricsNetgraphConfig}
                data={metricsNetgraphData}
                isLoading={isLoadingMetricsNetgraphData}
                features={selectedInsightsKeys || []}
            />
        </>
    );
};

export default MetricsNetgraph;
